import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

export const RMADetailLoaderContainer = styled(Box)`
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    box-sizing: border-box;
    max-width: 100%;
    margin: 0px auto;
    min-width: 0;
    min-height: 0;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 1000px;
    padding: 16px;

    @media only screen and (max-width: 768px) {
      padding: 6px;
      margin: 0px auto;
    }
`

export const RMAContainer = styled(Box)`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0px auto;
  min-width: 0;
  min-height: 0;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  padding: ${props => (props.isWmoEnabled ? '0' : '8px')};
  
  @media only screen and (max-width: 768px) {
    margin: 0px auto;
    padding: ${props => (props.isWmoEnabled ? '0' : '6px')};
  }
`

export const RMADetailBox1 = styled(Box)`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0px auto;
  min-width: 0;
  min-height: 0;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  padding: 16px;

  @media only screen and (max-width: 768px) {
    padding: 6px;
    margin: 0px auto;
  }
`

export const RMADetailBox2 = styled(Box)`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0px auto;
  min-width: 0;
  min-height: 0;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 1000px;
  padding: 16px;

  @media only screen and (max-width: 768px) {
    padding: 6px;
    margin: 0px auto;
  }
`
